import React, { useState } from 'react';
import {
  InfoCard,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent,
  SectionTitle,
  Table,
  TableHeader,
  TableRow,
  TableHeaderCell,
  TableBody,
  TableCell,
  List,
  ListItem,
  Alert,
  AlertContent,
  EmailLink,
  HoverText,
  Popup,
} from '../styles/info.styles';
import { Info } from 'lucide-react';

export default function BannerInformation() {
  const [showGifPopup, setShowGifPopup] = useState(false);
  const [showGifPopup2, setShowGifPopup2] = useState(false);
  return (
    <InfoCard>
      <CardHeader>
        <CardTitle>배너 정보 및 요청 작성 안내</CardTitle>
        <CardDescription>
          아래 광고 배너 정보를 참고하시어 원하시는 배너 위치 및 정보를 같이 알려주시면 최대한 신속하게 처리해
          드리겠습니다.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className='section'>
          <SectionTitle>1. 우측/좌측 스포츠 응원하기 배너 (PC)</SectionTitle>
          <Table>
            <TableBody>
              <TableRow>
                <TableCell className='font-medium'>사이즈</TableCell>
                <TableCell>313 x 53 픽셀</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className='font-medium'>파일형태</TableCell>
                <TableCell>
                  <HoverText onMouseEnter={() => setShowGifPopup(true)} onMouseLeave={() => setShowGifPopup(false)}>
                    이미지
                    {showGifPopup && <Popup>지원되는 이미지 형식은 GIF, PNG, JPEG, JPG입니다.</Popup>}
                  </HoverText>
                  , MP4
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className='font-medium'>용량</TableCell>
                <TableCell>
                  <List>
                    <ListItem>이미지: 1.5MB</ListItem>
                    <ListItem>MP4: 4MB</ListItem>
                  </List>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </div>

        <div className='section'>
          <SectionTitle>2. 우측/좌측 스포츠 응원하기 배너 (모바일)</SectionTitle>
          <Table>
            <TableBody>
              <TableRow>
                <TableCell className='font-medium'>사이즈</TableCell>
                <TableCell>173 x 53 픽셀</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className='font-medium'>파일형태</TableCell>
                <TableCell>
                  {' '}
                  <HoverText onMouseEnter={() => setShowGifPopup2(true)} onMouseLeave={() => setShowGifPopup2(false)}>
                    이미지
                    {showGifPopup2 && <Popup>지원되는 이미지 형식은 GIF, PNG, JPEG, JPG입니다.</Popup>}
                  </HoverText>
                  , MP4
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className='font-medium'>용량</TableCell>
                <TableCell>
                  <List>
                    <ListItem>이미지: 1.5MB</ListItem>
                    <ListItem>MP4: 4MB</ListItem>
                  </List>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </div>

        <div className='section'>
          <SectionTitle>추가 안내</SectionTitle>
          <Alert>
            <Info size={16} />
            <AlertContent>모든 광고는 롤링형식으로 진행됩니다.</AlertContent>
          </Alert>
          <Alert>
            <Info size={16} />
            <AlertContent>배너 위치는 우측 또는 좌측 중 선택 가능합니다.</AlertContent>
          </Alert>
          <Alert>
            <Info size={16} />
            <AlertContent>원하시는 배너 위치와 함께 파일 형태(이미지 또는 MP4)를 명확하게 알려주세요.</AlertContent>
          </Alert>
          <Alert>
            <Info size={16} />
            <AlertContent>파일 용량은 명시된 제한 용량 내에서 제작해주시기 바랍니다.</AlertContent>
          </Alert>
          <Alert>
            <Info size={16} />
            <AlertContent>
              그 외 궁금한 사항은 언제든지 <EmailLink href='mailto:pr@named.com'>pr@named.com</EmailLink>로
              문의해주세요.
            </AlertContent>
          </Alert>
        </div>
      </CardContent>
    </InfoCard>
  );
}
